/**
 * Which OS this laptop runs, for the Pi connection help (components/PiHelp.js): "mac",
 * "windows", "chromeos", "linux" or "other". Each OS shows its adapter and address in a
 * different place, and a browser can't see either, so the help has to say where to look.
 *
 * userAgentData first (Chromium: "macOS", "Windows", "Chrome OS", "Linux"), then the user
 * agent, which every browser has. ChromeOS is checked before Linux - its agent says both.
 * Neptune has the same function (src/lib/laptopPlatform.js).
 */
export function laptopPlatform(nav = typeof navigator !== "undefined" ? navigator : {}) {
    const platform = String(nav.userAgentData?.platform || nav.platform || "").toLowerCase();
    const agent = String(nav.userAgent || "").toLowerCase();
    if (platform.includes("chrome os") || platform.includes("chromeos") || agent.includes("cros")) return "chromeos";
    if (platform.includes("android") || agent.includes("android")) return "other";
    if (platform.startsWith("mac") || agent.includes("mac os x") || agent.includes("macintosh")) return "mac";
    if (platform.startsWith("win") || agent.includes("windows")) return "windows";
    if (platform.includes("linux") || agent.includes("linux")) return "linux";
    return "other";
}
